import React from "react";
import { getColorClasses } from "../../utils/getBackgroundColor";
import { SpacerBlock as SpacerBlockType } from "../../types/optimizely/blocks";
import classNames from "classnames";

type SpacerBlockProps = SpacerBlockType;

const SpacerBlock = ({ 
  height, 
  backgroundColor,
  hideOnMobile
}: SpacerBlockProps) => {
  const bgColor = getColorClasses(backgroundColor?.value);
  
  if (!height?.value || height.value < 0) {
    console.warn('SpacerBlock: Invalid height value');
    return null;
  }

  return (
    <div
      className={classNames(bgColor, {
        'hidden md:block': hideOnMobile?.value
      })}
      style={{ height: `${height.value}px` }}
    />
  );
};

export default SpacerBlock;
